import { render, staticRenderFns } from "./unknowPage.vue?vue&type=template&id=594beec2&scoped=true&"
import script from "./unknowPage.vue?vue&type=script&lang=js&"
export * from "./unknowPage.vue?vue&type=script&lang=js&"
import style0 from "./unknowPage.vue?vue&type=style&index=0&id=594beec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594beec2",
  null
  
)

export default component.exports